import { createIcon } from '@chakra-ui/react'

export const ExportIcon = () => (
  <>
    <path
      d="M12 3v10m0 0l4-4m-4 4l-4-4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Menu01Icon = createIcon({
  displayName: 'menu01Icon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
      <rect x="4" y="7" width="16" height="3" rx="3" fill="#ffffffff" />
      <rect x="4" y="12" width="16" height="3" rx="3" fill="#ffffffff" />
      <rect x="4" y="17" width="16" height="3" rx="3" fill="#ffffffff" />
    </svg>
  ),
})

export const LogoIcon = createIcon({
  displayName: 'logoIcon',
  viewBox: '0 0 138 29',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="138" height="29" fill="none">
        <g clipPath="url(#a)">
          <path
            fill="#FFEACA"
            d="M112.066 9.295c0-2.302.483-5.043 2.198-6.672 1.628-1.717 4.399-2.29 6.666-2.2 2.268-.09 5.039.483 6.666 2.2 1.717 1.63 2.199 4.355 2.199 6.672v1.007c0 2.28-.483 5.042-2.199 6.671-1.627 1.717-4.398 2.29-6.666 2.2-2.267.09-5.038-.483-6.666-2.2-1.715-1.629-2.198-4.325-2.198-6.671V9.295Z"
          />
          <path
            fill="#000"
            d="M106.192 20.417c.682-.22 2.922-1.178 2.922-4.214 0-3.6-3.016-4.562-4.799-4.562h-5.717a.716.716 0 0 0-.715.715v15.185c0 .394.32.716.715.716h1.899a.716.716 0 0 0 .715-.716v-6.19h2.127c1.63 1.265 2.712 4.853 2.956 6.306.059.348.355.6.705.6h1.933c.2 0 .392-.085.526-.233a.726.726 0 0 0 .185-.553c-.128-1.413-.749-4.19-3.452-7.054Zm-4.98-6.092h2.126c1.232 0 2.245.975 2.255 2.172a2.17 2.17 0 0 1-.642 1.572 2.177 2.177 0 0 1-1.549.642h-2.19v-4.386ZM124.507 27.424l-5.399-7.82v-.296a.11.11 0 0 0 .021-.023l4.55-6.588a.532.532 0 0 0-.436-.832h-2.582a.711.711 0 0 0-.594.319l-4.349 6.527h-.17v-6.355a.717.717 0 0 0-.716-.715h-1.898a.716.716 0 0 0-.715.715v15.185c0 .394.321.716.715.716h1.898a.717.717 0 0 0 .716-.716v-7.473h.08l4.832 7.848c.13.214.358.34.608.34h3.005a.53.53 0 0 0 .436-.831l-.002-.002ZM95.14 11.64h-1.986a.72.72 0 0 0-.698.562l-2.71 12.248h-.344l-2.926-12.26a.712.712 0 0 0-.695-.55h-2.08a.711.711 0 0 0-.695.55l-2.927 12.26h-.343l-2.71-12.247a.72.72 0 0 0-.698-.562h-2.24a.53.53 0 0 0-.514.662l3.906 15.414c.08.318.365.54.694.54h2.87c.334 0 .62-.227.697-.552l2.521-10.695h.567l2.52 10.695a.71.71 0 0 0 .695.552h2.966a.714.714 0 0 0 .692-.539l3.953-15.414a.53.53 0 0 0-.514-.662l-.001-.001ZM8.063 12.161a.603.603 0 0 0-.563-.395h-.953a.601.601 0 0 0-.563.395L.368 27.66a.284.284 0 0 0 .267.38h.616a.362.362 0 0 0 .34-.239l1.69-4.66h7.481l1.687 4.66a.362.362 0 0 0 .34.238h.618a.286.286 0 0 0 .232-.122.281.281 0 0 0 .035-.258L8.064 12.16v.001Zm2.266 9.78H3.715l3.254-8.975h.112l3.249 8.976h-.001ZM23.998 19.538a4.255 4.255 0 0 0-2.39-7.772h-4.474a.6.6 0 0 0-.599.6v7.31c0 .024.005.046.007.07v7.81c0 .326.266.592.592.592h4.889a4.536 4.536 0 0 0 4.529-4.533 4.539 4.539 0 0 0-2.554-4.078Zm-6.265-.462v-6.112h3.875a3.058 3.058 0 0 1 3.053 3.056 3.057 3.057 0 0 1-3.053 3.056h-3.875Zm-.007 1.2h3.882c.08 0 .16-.003.238-.008h.177a3.35 3.35 0 0 1 3.344 3.347 3.35 3.35 0 0 1-3.345 3.347h-4.296v-6.688.001ZM36.201 11.883c-3.792 0-6.877 3.087-6.877 6.882v2.506c0 3.796 3.085 6.883 6.877 6.883s6.877-3.087 6.877-6.883v-2.506c0-3.794-3.085-6.882-6.877-6.882Zm5.679 6.882v2.506a5.688 5.688 0 0 1-5.679 5.684 5.688 5.688 0 0 1-5.679-5.684v-2.506a5.688 5.688 0 0 1 5.679-5.683 5.688 5.688 0 0 1 5.679 5.683ZM58.027 11.642h-.479a.36.36 0 0 0-.36.36v10.577c0 2.422-1.928 4.437-4.298 4.492a4.373 4.373 0 0 1-3.183-1.254 4.375 4.375 0 0 1-1.33-3.153V12.001a.36.36 0 0 0-.359-.36h-.479a.36.36 0 0 0-.36.36v10.57c0 3.085 2.466 5.642 5.495 5.7h.11a5.559 5.559 0 0 0 3.92-1.606 5.567 5.567 0 0 0 1.68-4.002V12a.36.36 0 0 0-.359-.36l.002.002ZM72.265 11.766h-11.48a.36.36 0 0 0-.36.36v.479c0 .198.163.36.36.36h5.418v14.717c0 .196.16.357.357.357h.484c.196 0 .357-.16.357-.357V12.965h4.865a.36.36 0 0 0 .36-.36v-.48a.36.36 0 0 0-.36-.36Z"
          />
          <path
            fill="#FDE3F8"
            d="M126.754 22.534c0-1.417.297-3.102 1.352-4.105 1.002-1.056 2.706-1.408 4.102-1.353 1.394-.055 3.1.297 4.101 1.353 1.055 1.003 1.352 2.68 1.352 4.105v.62c0 1.403-.297 3.103-1.352 4.105-1.001 1.056-2.706 1.409-4.101 1.353-1.396.056-3.1-.297-4.102-1.353-1.055-1.002-1.352-2.662-1.352-4.105v-.62Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M.207.5h137.586v28H.207z" />
          </clipPath>
        </defs>
      </svg>{' '}
    </>
  ),
})
export const SwitchIcon = createIcon({
  displayName: 'switchIcon',
  viewBox: '0 0 36 21',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 21">
        <g clipPath="url(#a)">
          <rect width="36" height="20" y=".5" fill="#ECEFF3" rx="10" />
          <g filter="url(#b)">
            <circle cx="10" cy="10.5" r="8" fill="#fff" />
          </g>
        </g>
        <defs>
          <clipPath id="a">
            <rect width="36" height="20" y=".5" fill="#fff" rx="10" />
          </clipPath>
          <filter
            id="b"
            width="20"
            height="20"
            x="0"
            y="1.5"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0.643275 0 0 0 0 0.672823 0 0 0 0 0.725353 0 0 0 0.4 0" />
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8426_3312" />
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_8426_3312" result="shape" />
          </filter>
        </defs>
      </svg>
    </>
  ),
})

export const EyeIcon = () => (
  <>
    <path
      d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const EyeOffIcon = () => (
  <>
    <path
      d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const HomeIcon = () => (
  <>
    <path
      d="M9 21V13.6C9 13.0399 9 12.7599 9.109 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75993 12 10.04 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V21M2 9.5L11.04 2.72C11.3843 2.46181 11.5564 2.33271 11.7454 2.28294C11.9123 2.23902 12.0877 2.23902 12.2546 2.28295C12.4436 2.33271 12.6157 2.46181 12.96 2.72L22 9.5M4 8V17.8C4 18.9201 4 19.4802 4.21799 19.908C4.40974 20.2843 4.7157 20.5903 5.09202 20.782C5.51985 21 6.0799 21 7.2 21H16.8C17.9201 21 18.4802 21 18.908 20.782C19.2843 20.5903 19.5903 20.2843 19.782 19.908C20 19.4802 20 18.9201 20 17.8V8L13.92 3.44C13.2315 2.92361 12.8872 2.66542 12.5091 2.56589C12.1754 2.47804 11.8246 2.47804 11.4909 2.56589C11.1128 2.66542 10.7685 2.92361 10.08 3.44L4 8Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const WarningIcon = () => (
  <>
    <path
      d="M1.83334 7.99999C1.83334 4.59424 4.59425 1.83333 8.00001 1.83333C11.4058 1.83333 14.1667 4.59424 14.1667 8C14.1667 11.4058 11.4058 14.1667 8.00001 14.1667C4.59425 14.1667 1.83334 11.4057 1.83334 7.99999Z"
      fill="none"
    />
    <path
      d="M8.00001 8.66666L8.00001 5.16666M1.83334 7.99999C1.83334 4.59424 4.59425 1.83333 8.00001 1.83333C11.4058 1.83333 14.1667 4.59424 14.1667 8C14.1667 11.4058 11.4058 14.1667 8.00001 14.1667C4.59425 14.1667 1.83334 11.4057 1.83334 7.99999Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99999 11.25C8.32216 11.25 8.58332 10.9888 8.58332 10.6667C8.58332 10.3445 8.32216 10.0833 7.99999 10.0833C7.67782 10.0833 7.41666 10.3445 7.41666 10.6667C7.41666 10.9888 7.67782 11.25 7.99999 11.25Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </>
)

export const DataflowIcon4 = () => (
  <>
    <path
      d="M4 18V17.8C4 16.1198 4 15.2798 4.32698 14.638C4.6146 14.0735 5.07354 13.6146 5.63803 13.327C6.27976 13 7.11984 13 8.8 13H15.2C16.8802 13 17.7202 13 18.362 13.327C18.9265 13.6146 19.3854 14.0735 19.673 14.638C20 15.2798 20 16.1198 20 17.8V18M4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20C6 18.8954 5.10457 18 4 18ZM20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18ZM12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18ZM12 18V8M6 8H18C18.9319 8 19.3978 8 19.7654 7.84776C20.2554 7.64477 20.6448 7.25542 20.8478 6.76537C21 6.39782 21 5.93188 21 5C21 4.06812 21 3.60218 20.8478 3.23463C20.6448 2.74458 20.2554 2.35523 19.7654 2.15224C19.3978 2 18.9319 2 18 2H6C5.06812 2 4.60218 2 4.23463 2.15224C3.74458 2.35523 3.35523 2.74458 3.15224 3.23463C3 3.60218 3 4.06812 3 5C3 5.93188 3 6.39782 3.15224 6.76537C3.35523 7.25542 3.74458 7.64477 4.23463 7.84776C4.60218 8 5.06812 8 6 8Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Monitor02Icon = () => (
  <>
    <path
      d="M7.57181 21C8.90661 20.3598 10.41 20 12 20C13.59 20 15.0934 20.3598 16.4282 21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const GitMergeIcon = () => (
  <>
    <path
      d="M15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18ZM15 18C12.6131 18 10.3239 17.0518 8.63604 15.364C6.94821 13.6761 6 11.3869 6 9M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 9V21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const PresentationChart02Icon = () => (
  <>
    <path
      d="M12 16V21M18 21L14.0486 17.7072C13.3198 17.0998 12.9554 16.7962 12.5487 16.6801C12.19 16.5778 11.81 16.5778 11.4513 16.6801C11.0446 16.7962 10.6802 17.0998 9.95141 17.7072L6 21M8 11V12M12 9V12M16 7V12M22 3H2M3 3H21V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const BarChart01Icon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9C18.5523 9 19 9.44772 19 10V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V10C17 9.44772 17.4477 9 18 9Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 13C6.55228 13 7 13.4477 7 14V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V14C5 13.4477 5.44772 13 6 13Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C12.5523 3 13 3.44772 13 4V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V4C11 3.44772 11.4477 3 12 3Z"
      fill="currentColor"
    />
  </>
)

export const Speedometer01Icon = () => (
  <>
    <path
      d="M11 1V3.5M11 1C5.47715 1 1 5.47715 1 11M11 1C16.5228 1 21 5.47715 21 11M11 18.5V21M11 21C16.5228 21 21 16.5228 21 11M11 21C5.47715 21 1 16.5228 1 11M3.5 11H1M21 11H18.5M18.0784 18.0784L16.3047 16.3047M3.92163 18.0784L5.69715 16.3029M3.92163 4L5.65808 5.73645M18.0784 4L12.4999 9.5M13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Users02Icon = () => (
  <>
    <path
      d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Briefcase01Icon = () => (
  <>
    <path
      d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const File04Icon = () => (
  <>
    <path
      d="M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.89101C14.7599 8 15.0399 8 15.6 8H19.7305M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const File04FilledIcon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9989 1.95227C13 1.97612 13 1.98927 13 2.01558L13 6.43191C13 6.68429 12.9999 6.93008 13.017 7.13824C13.0356 7.36683 13.0797 7.63657 13.218 7.90799C13.4097 8.28432 13.7157 8.59028 14.092 8.78202C14.3634 8.92032 14.6332 8.96439 14.8618 8.98307C15.0699 9.00007 15.3157 9.00004 15.5681 9.00001L19.9845 9.00001C20.0107 9.00001 20.0238 9.00001 20.0477 9.00115C20.5415 9.02471 20.9756 9.45899 20.9989 9.95282C21 9.97664 21 9.98441 21 9.99994V17.2413C21 18.0463 21 18.7106 20.9558 19.2518C20.9099 19.8139 20.8113 20.3306 20.564 20.816C20.1805 21.5686 19.5686 22.1805 18.816 22.564C18.3306 22.8113 17.8139 22.9099 17.2518 22.9558C16.7106 23 16.0463 23 15.2413 23H8.75868C7.95372 23 7.28937 23 6.74818 22.9558C6.18608 22.9099 5.66938 22.8113 5.18404 22.564C4.43139 22.1805 3.81947 21.5686 3.43598 20.816C3.18868 20.3306 3.09012 19.8139 3.0442 19.2518C2.99998 18.7106 2.99999 18.0463 3 17.2413V6.75869C2.99999 5.95373 2.99998 5.28937 3.0442 4.74818C3.09012 4.18608 3.18868 3.66938 3.43598 3.18404C3.81947 2.43139 4.43139 1.81947 5.18404 1.43598C5.66938 1.18869 6.18608 1.09012 6.74818 1.0442C7.28936 0.99998 7.95371 0.999989 8.75866 1H12C12.0156 0.999995 12.0234 0.999991 12.0473 1.00112C12.541 1.02448 12.9753 1.4585 12.9989 1.95227Z"
        fill="currentColor"
      />
      <path
        d="M19.4686 6.92627C19.3484 7 19.2016 7 18.908 6.99999L15.8 6.99995C15.52 6.99995 15.38 6.99994 15.273 6.94545C15.1789 6.89751 15.1024 6.82102 15.0545 6.72694C15 6.61999 15 6.47998 15 6.19996L15 3.09204C15 2.79842 15 2.65161 15.0737 2.53134C15.1779 2.3615 15.4232 2.25996 15.6169 2.30652C15.754 2.33949 15.8497 2.43523 16.041 2.62672L19.3733 5.95904C19.5648 6.15033 19.6605 6.24598 19.6935 6.38313C19.74 6.57684 19.6385 6.82215 19.4686 6.92627Z"
        fill="currentColor"
      />
    </>
  )
}

export const PlusIcon = () => (
  <>
    <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const HelpCircleIcon = () => (
  <>
    <path
      d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </>
)

export const Mail02Icon = () => (
  <>
    <path
      d="M2.40217 9.46517C2.14388 9.28284 2.01474 9.19168 1.90462 9.16942C1.66199 9.12038 1.41078 9.25055 1.31093 9.47705C1.26562 9.57985 1.26562 9.73618 1.26563 10.0488V16.9636C1.26561 17.8223 1.2656 18.5309 1.31277 19.1082C1.33807 19.4179 1.69911 19.5425 1.92938 19.3339L7.46986 14.3149C7.73978 14.0704 7.87474 13.9481 7.91778 13.8077C7.95551 13.6847 7.94745 13.5521 7.89509 13.4345C7.83538 13.3004 7.68661 13.1954 7.38906 12.9853L2.40217 9.46517Z"
      fill="#FFBE4C"
    />
    <path
      d="M3.06952 21.1796C2.85231 21.3764 2.74371 21.4748 2.70072 21.6154C2.66739 21.7244 2.67737 21.8851 2.72394 21.9891C2.784 22.1234 2.88306 22.1929 3.08117 22.3319C3.24436 22.4465 3.41608 22.5499 3.59527 22.6412C4.11296 22.905 4.66411 23.0101 5.26368 23.0591C5.84095 23.1063 6.54959 23.1063 7.40821 23.1063H18.5897C19.4483 23.1063 20.157 23.1063 20.7342 23.0591C21.3338 23.0101 21.885 22.905 22.4027 22.6412C22.5818 22.5499 22.7536 22.4465 22.9168 22.3319C23.1149 22.1929 23.2139 22.1234 23.274 21.9891C23.3206 21.8851 23.3305 21.7244 23.2972 21.6154C23.2542 21.4748 23.1456 21.3764 22.9284 21.1796L16.4007 15.2663C16.276 15.1533 16.2136 15.0968 16.1461 15.0637C16.0182 15.001 15.8706 14.992 15.7361 15.0388C15.6651 15.0635 15.5963 15.1121 15.4589 15.2092C14.8751 15.6225 14.3625 15.9855 13.7779 16.1322C13.2666 16.2605 12.7315 16.2605 12.2202 16.1322C11.6356 15.9855 11.123 15.6225 10.5392 15.2092C10.4017 15.112 10.3329 15.0634 10.2618 15.0387C10.1274 14.992 9.9798 15.0009 9.85197 15.0636C9.7844 15.0967 9.722 15.1532 9.5972 15.2663L3.06952 21.1796Z"
      fill="#FFBE4C"
    />
    <path
      d="M24.0686 19.3339C24.2988 19.5425 24.6599 19.4179 24.6852 19.1082C24.7323 18.5309 24.7323 17.8223 24.7323 16.9637V10.0488C24.7323 9.73629 24.7323 9.58002 24.687 9.47725C24.5872 9.25067 24.3359 9.12047 24.0932 9.16957C23.9831 9.19183 23.854 9.28296 23.5959 9.46521L18.6089 12.9854C18.3114 13.1954 18.1626 13.3004 18.1029 13.4346C18.0506 13.5522 18.0425 13.6847 18.0802 13.8078C18.1233 13.9482 18.2582 14.0704 18.5281 14.315L24.0686 19.3339Z"
      fill="#FFBE4C"
    />
    <path
      d="M23.9639 5.72736C24.0803 5.89364 24.1386 5.97678 24.1565 6.10325C24.1705 6.2018 24.1465 6.33921 24.1 6.42722C24.0404 6.54016 23.9395 6.61136 23.7378 6.75375L14.3523 13.3788C13.5708 13.9305 13.405 14.0263 13.2587 14.063C13.0882 14.1057 12.9099 14.1057 12.7394 14.063C12.5931 14.0263 12.4273 13.9305 11.6458 13.3788L2.2602 6.75367C2.05847 6.61127 1.95761 6.54007 1.89795 6.42713C1.85145 6.33912 1.8275 6.2017 1.84147 6.10315C1.8594 5.97668 1.91763 5.89354 2.03409 5.72726C2.43333 5.15723 2.97655 4.68654 3.59527 4.37129C4.11296 4.10751 4.66411 4.00238 5.26368 3.95339C5.84095 3.90623 6.5496 3.90624 7.40822 3.90625H18.5897C19.4483 3.90624 20.157 3.90623 20.7342 3.95339C21.3338 4.00238 21.885 4.10751 22.4027 4.37129C23.0214 4.68656 23.5647 5.15728 23.9639 5.72736Z"
      fill="#FFBE4C"
    />
  </>
)

export const PasscodeLockIcon = () => (
  <>
    <path
      d="M5.70451 4.96875H20.2934C20.8557 4.96873 21.3408 4.96872 21.7403 5.00136C22.162 5.03581 22.5815 5.11188 22.9851 5.31753C23.5872 5.62433 24.0767 6.11386 24.3835 6.71598C24.5892 7.11959 24.6652 7.53902 24.6997 7.96072C24.7323 8.36026 24.7323 8.84533 24.7323 9.40762V12.4354C24.7323 13.0245 24.2547 13.5021 23.6656 13.5021C23.0765 13.5021 22.599 13.0245 22.599 12.4354V9.44875C22.599 8.83376 22.5981 8.43667 22.5734 8.13444C22.5498 7.84467 22.5096 7.73724 22.4827 7.6845C22.3804 7.48379 22.2173 7.32061 22.0166 7.21835C21.9638 7.19147 21.8564 7.15128 21.5666 7.12761C21.2644 7.10292 20.8673 7.10209 20.2523 7.10209H5.74563C5.13064 7.10209 4.73355 7.10292 4.43132 7.12761C4.14155 7.15128 4.03411 7.19147 3.98137 7.21835C3.78067 7.32061 3.61749 7.48379 3.51522 7.6845C3.48835 7.73724 3.44816 7.84467 3.42448 8.13444C3.39979 8.43667 3.39896 8.83376 3.39896 9.44875V13.2888C3.39896 13.9037 3.39979 14.3008 3.42448 14.6031C3.44816 14.8928 3.48835 15.0003 3.51522 15.053C3.61749 15.2537 3.78067 15.4169 3.98137 15.5192C4.03411 15.546 4.14155 15.5862 4.43132 15.6099C4.73355 15.6346 5.13064 15.6354 5.74563 15.6354H11.9323C12.5214 15.6354 12.999 16.113 12.999 16.7021C12.999 17.2912 12.5214 17.7688 11.9323 17.7688H5.70454C5.14225 17.7688 4.65714 17.7688 4.2576 17.7361C3.8359 17.7017 3.41646 17.6256 3.01286 17.42C2.41074 17.1132 1.9212 16.6236 1.61441 16.0215C1.40876 15.6179 1.33269 15.1985 1.29824 14.7768C1.26559 14.3773 1.26561 13.8922 1.26563 13.3299V9.40764C1.26561 8.84537 1.26559 8.36026 1.29824 7.96072C1.33269 7.53902 1.40876 7.11959 1.61441 6.71598C1.9212 6.11386 2.41074 5.62433 3.01286 5.31753C3.41646 5.11188 3.8359 5.03581 4.2576 5.00136C4.65713 4.96872 5.14224 4.96873 5.70451 4.96875Z"
      fill="#FFBE4C"
    />
    <path
      d="M6.33229 11.3688C6.33229 10.6324 6.92925 10.0354 7.66563 10.0354C8.40201 10.0354 8.99896 10.6324 8.99896 11.3688C8.99896 12.1051 8.40201 12.7021 7.66563 12.7021C6.92925 12.7021 6.33229 12.1051 6.33229 11.3688Z"
      fill="#FFBE4C"
    />
    <path
      d="M12.999 10.0354C12.2626 10.0354 11.6656 10.6324 11.6656 11.3688C11.6656 12.1051 12.2626 12.7021 12.999 12.7021C13.7353 12.7021 14.3323 12.1051 14.3323 11.3688C14.3323 10.6324 13.7353 10.0354 12.999 10.0354Z"
      fill="#FFBE4C"
    />
    <path
      d="M18.3323 10.0354C17.5959 10.0354 16.999 10.6324 16.999 11.3688C16.999 12.1051 17.5959 12.7021 18.3323 12.7021C19.0687 12.7021 19.6656 12.1051 19.6656 11.3688C19.6656 10.6324 19.0687 10.0354 18.3323 10.0354Z"
      fill="#FFBE4C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9323 16.9688C15.9323 15.3487 17.2456 14.0354 18.8656 14.0354C20.4857 14.0354 21.799 15.3487 21.799 16.9688V17.7987C22.0149 17.8242 22.2572 17.8772 22.5008 18.0013C22.9022 18.2058 23.2286 18.5322 23.4331 18.9336C23.5806 19.2231 23.6276 19.5108 23.6476 19.7546C23.6657 19.9767 23.6657 20.2389 23.6656 20.5081V21.4294C23.6657 21.6986 23.6657 21.9608 23.6476 22.1829C23.6276 22.4267 23.5806 22.7144 23.4331 23.0039C23.2286 23.4053 22.9022 23.7317 22.5008 23.9362C22.2113 24.0838 21.9236 24.1308 21.6797 24.1507C21.4577 24.1688 21.1955 24.1688 20.9263 24.1688H16.8049C16.5357 24.1688 16.2736 24.1688 16.0515 24.1507C15.8077 24.1308 15.52 24.0838 15.2305 23.9362C14.829 23.7317 14.5027 23.4053 14.2982 23.0039C14.1506 22.7144 14.1036 22.4267 14.0837 22.1829C14.0656 21.9608 14.0656 21.6987 14.0656 21.4294V20.5081C14.0656 20.2388 14.0656 19.9767 14.0837 19.7546C14.1036 19.5108 14.1506 19.2231 14.2982 18.9336C14.5027 18.5322 14.829 18.2058 15.2305 18.0013C15.474 17.8772 15.7163 17.8242 15.9323 17.7987V16.9688ZM19.6656 16.9688V17.7688H18.0656V16.9688C18.0656 16.5269 18.4238 16.1688 18.8656 16.1688C19.3075 16.1688 19.6656 16.5269 19.6656 16.9688Z"
      fill="#FFBE4C"
    />
  </>
)

export const SearchLgIcon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C13.7631 21 15.8415 20.2086 17.4733 18.8875L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L18.8875 17.4733C20.2086 15.8415 21 13.7631 21 11.5C21 6.25329 16.7467 2 11.5 2ZM4 11.5C4 7.35786 7.35786 4 11.5 4C15.6421 4 19 7.35786 19 11.5C19 15.6421 15.6421 19 11.5 19C7.35786 19 4 15.6421 4 11.5Z"
      fill="currentColor"
    />
  </>
)

export const ChevronDownIcon = () => (
  <>
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const HeartIcon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const MessageCircle02Icon = () => (
  <>
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Send01Icon = () => (
  <>
    <path
      d="M10.4995 13.5001L20.9995 3.00005M10.6271 13.8281L13.2552 20.5861C13.4867 21.1815 13.6025 21.4791 13.7693 21.566C13.9139 21.6414 14.0862 21.6415 14.2308 21.5663C14.3977 21.4796 14.5139 21.1821 14.7461 20.587L21.3364 3.69925C21.5461 3.16207 21.6509 2.89348 21.5935 2.72185C21.5437 2.5728 21.4268 2.45583 21.2777 2.40604C21.1061 2.34871 20.8375 2.45352 20.3003 2.66315L3.41258 9.25349C2.8175 9.48572 2.51997 9.60183 2.43326 9.76873C2.35809 9.91342 2.35819 10.0857 2.43353 10.2303C2.52043 10.3971 2.81811 10.5128 3.41345 10.7444L10.1715 13.3725C10.2923 13.4195 10.3527 13.443 10.4036 13.4793C10.4487 13.5114 10.4881 13.5509 10.5203 13.596C10.5566 13.6468 10.5801 13.7073 10.6271 13.8281Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const DotsHorizontalIcon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12Z"
      fill="currentColor"
    />
  </>
)

export const ArrowNarrowUpRightIcon = () => (
  <>
    <path
      d="M6 18L18 6M18 6H10M18 6V14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)
export const Buidling04Icon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16146 2H14.8385C15.3657 1.99998 15.8205 1.99997 16.195 2.03057C16.5904 2.06287 16.9836 2.13419 17.362 2.32698C17.9265 2.6146 18.3854 3.07355 18.673 3.63803C18.8658 4.01641 18.9371 4.40963 18.9694 4.80498C19 5.17952 19 5.63436 19 6.16146V20H20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21C3 20.4477 3.44772 20 4 20H5L5 6.16146C4.99998 5.63431 4.99997 5.17955 5.03057 4.80498C5.06287 4.40963 5.13419 4.01641 5.32698 3.63803C5.6146 3.07355 6.07354 2.6146 6.63803 2.32698C7.01641 2.13419 7.40963 2.06287 7.80497 2.03057C8.17953 1.99997 8.63434 1.99998 9.16146 2ZM8 7C8 6.44772 8.44772 6 9 6H15C15.5523 6 16 6.44772 16 7C16 7.55229 15.5523 8 15 8H9C8.44772 8 8 7.55229 8 7ZM8 11C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H9C8.44772 12 8 11.5523 8 11ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H9Z"
      fill="currentColor"
    />
  </>
)

export const Home03Icon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4909 1.31589C11.8247 1.22804 12.1755 1.22804 12.5092 1.31589C12.8964 1.41782 13.225 1.66653 13.4871 1.8649L13.5601 1.92L14.1668 2.37507C14.2432 2.43182 14.3206 2.49004 14.3993 2.54927L14.5201 2.64L22.6001 8.7C23.0419 9.03137 23.1314 9.65817 22.8001 10.1C22.4687 10.5418 21.8419 10.6314 21.4001 10.3L21.0001 10V17.8386C21.0001 18.3657 21.0001 18.8205 20.9695 19.195C20.9372 19.5904 20.8659 19.9836 20.6731 20.362C20.3855 20.9265 19.9265 21.3854 19.362 21.673C18.9837 21.8658 18.5904 21.9371 18.1951 21.9694C17.8205 22 17.3658 22 16.8386 22H7.1615C6.63436 22 6.1796 22 5.80503 21.9694C5.40969 21.9371 5.01647 21.8658 4.63809 21.673C4.07361 21.3854 3.61466 20.9265 3.32704 20.362C3.13425 19.9836 3.06293 19.5904 3.03063 19.195C3.00003 18.8205 3.00004 18.3657 3.00006 17.8385L3.00006 10L2.60006 10.3C2.15823 10.6314 1.53143 10.5418 1.20006 10.1C0.868688 9.65817 0.958231 9.03137 1.40006 8.7L9.48006 2.64L9.60074 2.5493C9.67945 2.49008 9.75681 2.43187 9.83322 2.37513L10.4401 1.92L10.5131 1.8649C10.7751 1.66653 11.1037 1.41782 11.4909 1.31589ZM9.00006 13.6V20H15.0001V13.6C15.0001 13.0399 15.0001 12.7599 14.8911 12.546C14.7952 12.3578 14.6422 12.2049 14.4541 12.109C14.2401 12 13.9601 12 13.4001 12H10.6001C10.04 12 9.75998 12 9.54607 12.109C9.35791 12.2049 9.20493 12.3578 9.10905 12.546C9.00006 12.7599 9.00006 13.0399 9.00006 13.6Z"
      fill="currentColor"
    />
  </>
)

export const XCircleIcon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L13.4142 12L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L12 13.4142L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L10.5858 12L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L12 10.5858L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289Z"
      fill="currentColor"
    />
  </>
)

export const Image03Icon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 6C6.34315 6 5 7.34315 5 9C5 10.6569 6.34315 12 8 12C9.65685 12 11 10.6569 11 9C11 7.34315 9.65685 6 8 6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2413 2H6.7587C5.95374 1.99999 5.28937 1.99998 4.74818 2.04419C4.18608 2.09012 3.66937 2.18868 3.18404 2.43598C2.43139 2.81947 1.81947 3.43139 1.43598 4.18404C1.18868 4.66937 1.09012 5.18608 1.04419 5.74818C0.999978 6.28937 0.999988 6.95372 1 7.75869V16.2413C0.999988 17.0463 0.999978 17.7106 1.04419 18.2518C1.09012 18.8139 1.18868 19.3306 1.43598 19.816C1.81947 20.5686 2.43139 21.1805 3.18404 21.564C3.66937 21.8113 4.18608 21.9099 4.74818 21.9558C4.86687 21.9655 4.99148 21.9731 5.1222 21.979C5.12976 21.9797 5.13706 21.9804 5.14408 21.981C5.35805 21.9999 5.62381 21.9999 5.89419 21.9999L6.4005 21.9998C6.51667 22 6.63604 22 6.75868 22H17.2413C17.363 22 17.4815 22 17.5968 21.9999H18.1059C18.3763 21.9999 18.6421 21.9999 18.856 21.981C18.8631 21.9803 18.8704 21.9797 18.878 21.979C19.0087 21.9731 19.1332 21.9655 19.2518 21.9558C19.8139 21.9099 20.3306 21.8113 20.816 21.564C21.5686 21.1805 22.1805 20.5686 22.564 19.816C22.8113 19.3306 22.9099 18.8139 22.9558 18.2518C23 17.7106 23 17.0463 23 16.2413V15.0008V14.9989V7.75868C23 6.95372 23 6.28937 22.9558 5.74818C22.9099 5.18608 22.8113 4.66937 22.564 4.18404C22.1805 3.43139 21.5686 2.81947 20.816 2.43598C20.3306 2.18868 19.8139 2.09012 19.2518 2.04419C18.7106 1.99998 18.0463 1.99999 17.2413 2ZM21 12.5856V7.8C21 6.94342 20.9992 6.36113 20.9624 5.91104C20.9266 5.47262 20.8617 5.24842 20.782 5.09202C20.5903 4.7157 20.2843 4.40973 19.908 4.21799C19.7516 4.1383 19.5274 4.07337 19.089 4.03755C18.6389 4.00078 18.0566 4 17.2 4H6.8C5.94342 4 5.36113 4.00078 4.91104 4.03755C4.47262 4.07337 4.24842 4.1383 4.09202 4.21799C3.7157 4.40973 3.40973 4.7157 3.21799 5.09202C3.1383 5.24842 3.07337 5.47262 3.03755 5.91104C3.00078 6.36113 3 6.94342 3 7.8V16.2C3 17.0566 3.00078 17.6389 3.03755 18.089C3.07337 18.5274 3.1383 18.7516 3.21799 18.908C3.38624 19.2382 3.64243 19.5142 3.95693 19.7065C4.01521 19.6184 4.07265 19.548 4.11525 19.4971C4.25313 19.3324 4.44106 19.1446 4.63226 18.9534L10.1841 13.4016C10.3626 13.2231 10.5364 13.0493 10.6956 12.9141C10.8704 12.7657 11.0923 12.6061 11.382 12.5119C11.7837 12.3814 12.2164 12.3814 12.6181 12.5119C12.9078 12.6061 13.1297 12.7657 13.3045 12.9141C13.4638 13.0492 13.6375 13.2231 13.816 13.4015L14 13.5856L16.1841 11.4016C16.3625 11.2231 16.5363 11.0493 16.6955 10.9141C16.8704 10.7657 17.0922 10.6061 17.382 10.5119C17.7837 10.3814 18.2163 10.3814 18.618 10.5119C18.9077 10.6061 19.1296 10.7657 19.3045 10.9141C19.4637 11.0493 19.6375 11.2231 19.8159 11.4016L21 12.5856Z"
      fill="currentColor"
    />
  </>
)

export const PlaySquareIcon = () => {
  return (
    <>
      <path
        d="M9.5 8.96533C9.5 8.48805 9.5 8.24941 9.59974 8.11618C9.68666 8.00007 9.81971 7.92744 9.96438 7.9171C10.1304 7.90525 10.3311 8.03429 10.7326 8.29239L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.6729L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 15.9999 9.59974 15.8838C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96533Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const ListIcon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 12C8 11.4477 8.44772 11 9 11L21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L9 13C8.44772 13 8 12.5523 8 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 6C8 5.44772 8.44772 5 9 5L21 5C21.5523 5 22 5.44772 22 6C22 6.55229 21.5523 7 21 7L9 7C8.44772 7 8 6.55228 8 6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 18C8 17.4477 8.44772 17 9 17L21 17C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19L9 19C8.44772 19 8 18.5523 8 18Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6C2 4.89543 2.89543 4 4 4C5.10457 4 6 4.89543 6 6C6 7.10457 5.10457 8 4 8C2.89543 8 2 7.10457 2 6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 18C2 16.8954 2.89543 16 4 16C5.10457 16 6 16.8954 6 18C6 19.1046 5.10457 20 4 20C2.89543 20 2 19.1046 2 18Z"
      fill="currentColor"
    />
  </>
)

export const NavigationPointer01Icon = () => (
  <>
    <path
      d="M21.5951 1.4575C21.1993 1.32529 20.8308 1.4209 20.6476 1.47411C20.448 1.5321 20.2101 1.625 19.9714 1.7182L3.01429 8.3356C2.74746 8.43969 2.48901 8.54051 2.28953 8.63914C2.11718 8.72436 1.75084 8.91405 1.54635 9.30766C1.32085 9.74172 1.32115 10.2585 1.54717 10.6923C1.75212 11.0856 2.11868 11.2749 2.29113 11.3599C2.49072 11.4583 2.74924 11.5588 3.01619 11.6626L9.72748 14.2725L12.3374 20.9837C12.4412 21.2507 12.5417 21.5093 12.6401 21.7089C12.7251 21.8813 12.9144 22.2479 13.3077 22.4528C13.7415 22.6788 14.2583 22.6791 14.6923 22.4536C15.086 22.2492 15.2756 21.8828 15.3609 21.7105C15.4595 21.511 15.5603 21.2526 15.6644 20.9858L22.2818 4.02861C22.375 3.7899 22.4679 3.55198 22.5259 3.35235C22.5791 3.16916 22.6747 2.8007 22.5425 2.40493C22.3931 1.95779 22.0422 1.60688 21.5951 1.4575Z"
      fill="currentColor"
    />
  </>
)

export const ChevronLeftIcon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
      fill="currentColor"
    />
  </>
)

export const ChevronRightIcon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
      fill="currentColor"
    />
  </>
)

export const CalendarIcon = () => (
  <>
    <path
      d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const ChevronSelectorVerticalIcon = () => (
  <>
    <path
      d="M7 15L12 20L17 15M7 9L12 4L17 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const ChevronUpIcon = () => (
  <>
    <path d="M18 15L12 9L6 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>
)

export const ArrowLeftIcon = () => (
  <>
    <path
      d="M20 12H4M4 12L10 18M4 12L10 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Edit05Icon = () => (
  <>
    <path
      d="M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const BarChart012Icon = () => (
  <>
    <path
      d="M9 12H4.6C4.03995 12 3.75992 12 3.54601 12.109C3.35785 12.2049 3.20487 12.3578 3.10899 12.546C3 12.7599 3 13.0399 3 13.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 8.6C9 8.03995 9 7.75992 9.10899 7.54601C9.20487 7.35785 9.35785 7.20487 9.54601 7.10899C9.75992 7 10.0399 7 10.6 7H13.4C13.9601 7 14.2401 7 14.454 7.10899C14.6422 7.20487 14.7951 7.35785 14.891 7.54601C15 7.75992 15 8.03995 15 8.6V21M15 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H16.6C16.0399 3 15.7599 3 15.546 3.10899C15.3578 3.20487 15.2049 3.35785 15.109 3.54601C15 3.75992 15 4.03995 15 4.6V8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const CheckCircleBrokenIcon = () => (
  <>
    <path
      d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const CheckCircleFilledIcon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM17.2071 9.70711C17.5976 9.31658 17.5976 8.68342 17.2071 8.29289C16.8166 7.90237 16.1834 7.90237 15.7929 8.29289L10.5 13.5858L8.20711 11.2929C7.81658 10.9024 7.18342 10.9024 6.79289 11.2929C6.40237 11.6834 6.40237 12.3166 6.79289 12.7071L9.79289 15.7071C10.1834 16.0976 10.8166 16.0976 11.2071 15.7071L17.2071 9.70711Z"
        fill="currentColor"
      />
    </>
  )
}

export const UploadCloud02Icon = () => (
  <>
    <path
      d="M8 16L12 12M12 12L16 16M12 12V21M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const htIcon = () => (
  <>
    <path
      d="M7 17L17 7M17 7H7M17 7V17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const RefreshCCW01Icon = () => (
  <>
    <path
      d="M2 10C2 10 4.00498 7.26822 5.63384 5.63824C7.26269 4.00827 9.5136 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.89691 21 4.43511 18.2543 3.35177 14.5M2 10V4M2 10H8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Trash04Icon = () => (
  <>
    <path
      d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const AlertCircleIcon = () => (
  <>
    <path
      d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const UserPlus01Icon = () => (
  <>
    <path
      d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Copy03Icon = () => (
  <>
    <path
      d="M5 15C5 17.8284 5 19.2426 5.87868 20.1213C6.75736 21 8.17157 21 11 21H13C15.8284 21 17.2426 21 18.1213 20.1213C19 19.2426 19 17.8284 19 15V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M10 3.5C10 2.67157 9.32843 2 8.5 2H5C3.89543 2 3 2.89543 3 4V8.5C3 9.32843 3.67157 10 4.5 10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </>
)

export const Copy06Icon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1458 4.05118C16.5289 4.00078 15.7366 4 14.6 4H7.5C6.94772 4 6.5 3.55229 6.5 3C6.5 2.44772 6.94772 2 7.5 2L14.6428 2C15.7266 1.99999 16.6007 1.99998 17.3086 2.05782C18.0375 2.11737 18.6777 2.24318 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C21.7568 5.32234 21.8826 5.96253 21.9422 6.69138C22 7.39926 22 8.27342 22 9.35722V16.5C22 17.0523 21.5523 17.5 21 17.5C20.4477 17.5 20 17.0523 20 16.5V9.4C20 8.26339 19.9992 7.47108 19.9488 6.85424C19.8994 6.24907 19.8072 5.90138 19.673 5.63803C19.3854 5.07354 18.9265 4.6146 18.362 4.32698C18.0986 4.19279 17.7509 4.10062 17.1458 4.05118Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.16146 5.5H14.3385C14.8657 5.49998 15.3205 5.49997 15.695 5.53057C16.0904 5.56287 16.4836 5.63419 16.862 5.82698C17.4265 6.1146 17.8854 6.57354 18.173 7.13803C18.3658 7.51641 18.4371 7.90963 18.4694 8.30497C18.5 8.67955 18.5 9.13432 18.5 9.66148V17.8385C18.5 18.3657 18.5 18.8204 18.4694 19.195C18.4371 19.5904 18.3658 19.9836 18.173 20.362C17.8854 20.9265 17.4265 21.3854 16.862 21.673C16.4836 21.8658 16.0904 21.9371 15.695 21.9694C15.3205 22 14.8657 22 14.3385 22H6.16148C5.63432 22 5.17955 22 4.80497 21.9694C4.40963 21.9371 4.01641 21.8658 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2.13419 19.9836 2.06287 19.5904 2.03057 19.195C1.99997 18.8205 1.99998 18.3657 2 17.8385V9.66146C1.99998 9.13431 1.99997 8.67954 2.03057 8.30497C2.06287 7.90963 2.13419 7.51641 2.32698 7.13803C2.6146 6.57354 3.07354 6.1146 3.63803 5.82698C4.01641 5.63419 4.40963 5.56287 4.80497 5.53057C5.17955 5.49997 5.63431 5.49998 6.16146 5.5Z"
      fill="currentColor"
    />
  </>
)

export const RefreshCCW04Icon = () => (
  <>
    <path
      d="M12.2929 0.892869C12.6834 0.502344 13.3166 0.502344 13.7071 0.892869C14.0976 1.28339 14.0976 1.91656 13.7071 2.30708L13.4102 2.60395C17.9882 3.28521 21.5 7.23249 21.5 12C21.5 15.1587 19.9574 17.9572 17.5889 19.6828C17.1425 20.0081 16.517 19.9098 16.1918 19.4635C15.8665 19.0171 15.9648 18.3916 16.4111 18.0664C18.2853 16.701 19.5 14.4924 19.5 12C19.5 8.3558 16.9009 5.31865 13.4553 4.6411L13.7071 4.89287C14.0976 5.28339 14.0976 5.91656 13.7071 6.30708C13.3166 6.69761 12.6834 6.69761 12.2929 6.30708L10.2929 4.30708C9.90237 3.91656 9.90237 3.28339 10.2929 2.89287L12.2929 0.892869Z"
      fill="currentColor"
    />
    <path
      d="M6.41115 4.3172C6.85752 3.99198 7.48302 4.0902 7.80824 4.53658C8.13345 4.98296 8.03523 5.60846 7.58885 5.93367C5.71475 7.29908 4.5 9.50765 4.5 12C4.5 15.6443 7.0991 18.6814 10.5447 19.3589L10.2929 19.1071C9.90237 18.7166 9.90237 18.0834 10.2929 17.6929C10.6834 17.3024 11.3166 17.3024 11.7071 17.6929L13.7071 19.6929C14.0976 20.0834 14.0976 20.7166 13.7071 21.1071L11.7071 23.1071C11.3166 23.4977 10.6834 23.4977 10.2929 23.1071C9.90237 22.7166 9.90237 22.0834 10.2929 21.6929L10.5897 21.3961C6.01183 20.7148 2.5 16.7675 2.5 12C2.5 8.84135 4.04258 6.04285 6.41115 4.3172Z"
      fill="currentColor"
    />
  </>
)

export const Settings01Icon = () => (
  <>
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </>
)

export const LogOut03Icon = () => (
  <>
    <path
      d="M16 17L21 12M21 12L16 7M21 12H9M12 17C12 17.2956 12 17.4434 11.989 17.5714C11.8748 18.902 10.8949 19.9968 9.58503 20.2573C9.45903 20.2823 9.31202 20.2987 9.01835 20.3313L7.99694 20.4448C6.46248 20.6153 5.69521 20.7005 5.08566 20.5055C4.27293 20.2454 3.60942 19.6515 3.26118 18.8725C3 18.2882 3 17.5162 3 15.9723V8.0277C3 6.48377 3 5.7118 3.26118 5.12752C3.60942 4.34848 4.27293 3.7546 5.08566 3.49453C5.69521 3.29947 6.46246 3.38472 7.99694 3.55522L9.01835 3.66871C9.31212 3.70135 9.45901 3.71767 9.58503 3.74273C10.8949 4.00316 11.8748 5.09804 11.989 6.42861C12 6.55663 12 6.70442 12 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </>
)

export const ArrowUpRightIcon = () => (
  <>
    <path
      d="M7 17L17 7M17 7H7M17 7V17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Repeat01Icon = () => (
  <>
    <path
      d="M17 2L21 6M21 6L17 10M21 6H7.8C6.11984 6 5.27976 6 4.63803 6.32698C4.07354 6.6146 3.6146 7.07354 3.32698 7.63803C3 8.27976 3 9.11984 3 10.8V11M3 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V13M3 18L7 22M3 18L7 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const Link03Icon = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7755 2.75074C13.9071 1.65779 15.4227 1.05302 16.9959 1.06669C18.5691 1.08036 20.074 1.71138 21.1864 2.82383C22.2988 3.93628 22.9299 5.44115 22.9435 7.01433C22.9572 8.58751 22.3524 10.1031 21.2595 11.2347L21.2473 11.2471L18.2474 14.247C17.6392 14.8555 16.9072 15.326 16.101 15.6267C15.2949 15.9274 14.4336 16.0513 13.5754 15.9898C12.7172 15.9283 11.8823 15.683 11.1273 15.2705C10.3723 14.858 9.71478 14.288 9.19943 13.599C8.86863 13.1568 8.95897 12.5301 9.40122 12.1993C9.84347 11.8685 10.4702 11.9588 10.801 12.401C11.1445 12.8604 11.5829 13.2404 12.0862 13.5154C12.5896 13.7904 13.1462 13.9539 13.7183 13.9949C14.2904 14.0359 14.8646 13.9533 15.402 13.7529C15.9394 13.5524 16.4275 13.2387 16.833 12.833L19.8266 9.83941C20.5516 9.08563 20.9527 8.07776 20.9436 7.03171C20.9345 5.98292 20.5138 4.97967 19.7722 4.23804C19.0306 3.49641 18.0273 3.07573 16.9785 3.06662C15.932 3.05752 14.9237 3.45893 14.1698 4.18456L12.4552 5.88919C12.0636 6.27858 11.4304 6.27673 11.041 5.88507C10.6516 5.49341 10.6535 4.86024 11.0452 4.47086L12.7652 2.76086L12.7755 2.75074Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.89935 8.37331C8.70546 8.07261 9.56681 7.94879 10.425 8.01025C11.2832 8.07171 12.1181 8.31701 12.8731 8.72952C13.6281 9.14203 14.2856 9.71209 14.801 10.401C15.1318 10.8433 15.0414 11.47 14.5992 11.8008C14.1569 12.1316 13.5302 12.0413 13.1994 11.599C12.8559 11.1397 12.4175 10.7597 11.9142 10.4847C11.4108 10.2096 10.8542 10.0461 10.2821 10.0051C9.71 9.96416 9.13577 10.0467 8.59836 10.2472C8.06095 10.4476 7.57294 10.7613 7.16743 11.167L4.17379 14.1606C3.44875 14.9144 3.0477 15.9223 3.05679 16.9683C3.06591 18.0171 3.48658 19.0204 4.22821 19.762C4.96985 20.5036 5.9731 20.9243 7.02188 20.9334C8.06793 20.9425 9.0758 20.5415 9.82957 19.8164L11.5331 18.1129C11.9236 17.7224 12.5568 17.7224 12.9473 18.1129C13.3378 18.5034 13.3378 19.1366 12.9473 19.5271L11.2373 21.2371L11.2249 21.2493C10.0933 22.3423 8.57768 22.947 7.0045 22.9334C5.43132 22.9197 3.92645 22.2887 2.814 21.1762C1.70155 20.0638 1.07054 18.5589 1.05687 16.9857C1.0432 15.4125 1.64796 13.8969 2.74091 12.7653L2.75309 12.7529L5.75296 9.75305C5.75292 9.75309 5.75301 9.75301 5.75296 9.75305C6.3612 9.14463 7.0933 8.67399 7.89935 8.37331Z"
      fill="currentColor"
    />
  </>
)

export const Flag02Icon = () => (
  <>
    <path
      d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V4C20 4 19 5 16 5C13 5 11 3 8 3C5 3 4 4 4 4M4 22L4 2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const FireInteractionIcon = () => (
  <>
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#FFDFE5" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="white" />
    <path d="M5 14.7H15V4.7H5V14.7Z" fill="solid.900" />
  </>
)

export const PencilLineIcon = () => (
  <>
    <path
      d="M21 21.0001H13M2.5 21.5001L8.04927 19.3657C8.40421 19.2292 8.58168 19.161 8.74772 19.0718C8.8952 18.9927 9.0358 18.9013 9.16804 18.7987C9.31692 18.6831 9.45137 18.5487 9.72028 18.2798L21 7.00006C22.1046 5.89549 22.1046 4.10463 21 3.00006C19.8955 1.89549 18.1046 1.89549 17 3.00006L5.72028 14.2798C5.45138 14.5487 5.31692 14.6831 5.20139 14.832C5.09877 14.9643 5.0074 15.1049 4.92823 15.2523C4.83911 15.4184 4.77085 15.5959 4.63433 15.9508L2.5 21.5001ZM2.5 21.5001L4.55812 16.149C4.7054 15.7661 4.77903 15.5746 4.90534 15.4869C5.01572 15.4103 5.1523 15.3813 5.2843 15.4065C5.43533 15.4354 5.58038 15.5804 5.87048 15.8705L8.12957 18.1296C8.41967 18.4197 8.56472 18.5648 8.59356 18.7158C8.61877 18.8478 8.58979 18.9844 8.51314 19.0947C8.42545 19.2211 8.23399 19.2947 7.85107 19.442L2.5 21.5001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export const XCloseIcon = () => (
  <>
    <path
      d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
      fill="currentColor"
    />
  </>
)

export const PlayIcon = () => (
  <>
    <path
      d="M5 4.98963C5 4.01847 5 3.53289 5.20249 3.26522C5.37889 3.03203 5.64852 2.88773 5.9404 2.8703C6.27544 2.8503 6.67946 3.11965 7.48752 3.65835L18.0031 10.6687C18.6708 11.1139 19.0046 11.3364 19.1209 11.6169C19.2227 11.8622 19.2227 12.1378 19.1209 12.3831C19.0046 12.6636 18.6708 12.8862 18.0031 13.3313L7.48752 20.3417C6.67946 20.8804 6.27544 21.1497 5.9404 21.1297C5.64852 21.1123 5.37889 20.968 5.20249 20.7348C5 20.4671 5 19.9815 5 19.0104V4.98963Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="currentColor"
    />
  </>
)

export const PauseCircleIcon = () => (
  <>
    <path
      d="M9.5 15V9M14.5 15V9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const CircleIcon = () => (
  <>
    <path
      d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1Z"
      fill="currentColor"
    />
  </>
)

export const DeleteIcon = () => (
  <>
    <path
      d="M17 9L11 15M11 9L17 15M2.72 12.96L7.04 18.72C7.392 19.1893 7.568 19.424 7.79105 19.5932C7.9886 19.7432 8.21232 19.855 8.45077 19.9231C8.72 20 9.01334 20 9.6 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H9.6C9.01334 4 8.72 4 8.45077 4.07689C8.21232 4.14499 7.9886 4.25685 7.79105 4.40675C7.568 4.576 7.392 4.81067 7.04 5.28L2.72 11.04C2.46181 11.3843 2.33271 11.5564 2.28294 11.7454C2.23902 11.9123 2.23902 12.0877 2.28294 12.2546C2.33271 12.4436 2.46181 12.6157 2.72 12.96Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export const Grid01Icon = () => {
  return (
    <>
      <path
        d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ClockFillIcon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V12C11 12.3788 11.214 12.725 11.5528 12.8944L15.5528 14.8944C16.0468 15.1414 16.6474 14.9412 16.8944 14.4472C17.1414 13.9532 16.9412 13.3526 16.4472 13.1056L13 11.382V6Z"
        fill="currentColor"
      />
    </>
  )
}

export const Loading02Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C12.5523 1 13 1.44772 13 2V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V2C11 1.44772 11.4477 1 12 1Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17C12.5523 17 13 17.4477 13 18V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V18C11 17.4477 11.4477 17 12 17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 11.4477 1.44772 11 2 11H6C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H2C1.44772 13 1 12.5523 1 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 12C17 11.4477 17.4477 11 18 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H18C17.4477 13 17 12.5523 17 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5429 15.5429C15.9334 15.1524 16.5666 15.1524 16.9571 15.5429L19.7855 18.3713C20.1761 18.7618 20.1761 19.395 19.7855 19.7855C19.395 20.1761 18.7618 20.1761 18.3713 19.7855L15.5429 16.9571C15.1524 16.5666 15.1524 15.9334 15.5429 15.5429Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7855 4.29283C20.1761 4.68336 20.1761 5.31652 19.7855 5.70705L16.9571 8.53548C16.5666 8.926 15.9334 8.926 15.5429 8.53548C15.1524 8.14495 15.1524 7.51179 15.5429 7.12126L18.3713 4.29283C18.7618 3.90231 19.395 3.90231 19.7855 4.29283Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.45711 15.5429C8.84763 15.9334 8.84763 16.5666 8.45711 16.9571L5.62868 19.7855C5.23815 20.1761 4.60499 20.1761 4.21447 19.7855C3.82394 19.395 3.82394 18.7618 4.21447 18.3713L7.04289 15.5429C7.43342 15.1524 8.06658 15.1524 8.45711 15.5429Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.21447 4.29283C4.60499 3.90231 5.23815 3.90231 5.62868 4.29283L8.45711 7.12126C8.84763 7.51179 8.84763 8.14495 8.45711 8.53548C8.06658 8.926 7.43342 8.926 7.04289 8.53548L4.21447 5.70705C3.82394 5.31652 3.82394 4.68336 4.21447 4.29283Z"
        fill="currentColor"
      />
    </>
  )
}

export const ThumbsUpIcon = () => {
  return (
    <>
      <path
        d="M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const LigthBulb01Icon = () => {
  return (
    <>
      <path
        d="M15 16.5V19C15 19.9319 15 20.3978 14.8478 20.7654C14.6448 21.2554 14.2554 21.6448 13.7654 21.8478C13.3978 22 12.9319 22 12 22C11.0681 22 10.6022 22 10.2346 21.8478C9.74458 21.6448 9.35523 21.2554 9.15224 20.7654C9 20.3978 9 19.9319 9 19V16.5M15 16.5C17.6489 15.3427 19.5 12.5755 19.5 9.5C19.5 5.35786 16.1421 2 12 2C7.85786 2 4.5 5.35786 4.5 9.5C4.5 12.5755 6.35114 15.3427 9 16.5M15 16.5H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const FireIcon = () => {
  return (
    <>
      <g clipPath="url(#clip0_1545_11221)">
        <path
          d="M6.14999 0.53004C6.08953 0.493924 6.02041 0.474854 5.94999 0.474854C5.87956 0.474854 5.81045 0.493924 5.74999 0.53004C5.70011 0.569554 5.66646 0.625984 5.65541 0.688644C5.64435 0.751303 5.65665 0.815843 5.68999 0.87004C6.91999 3.00004 7.17999 5.90004 5.49999 7.50004C4.85361 6.95686 4.34045 6.27265 3.99999 5.50004C3.37872 5.84509 2.86384 6.35374 2.51125 6.97076C2.15867 7.58779 1.98185 8.28961 1.99999 9.00004C2.02535 9.62632 2.17572 10.2412 2.44226 10.8085C2.7088 11.3758 3.08611 11.8841 3.552 12.3034C4.01789 12.7227 4.56295 13.0445 5.15509 13.25C5.74724 13.4556 6.3745 13.5406 6.99999 13.5C10.22 13.5 11.89 11.5 12 9.00004C12.13 6.00004 9.99999 2.31004 6.14999 0.53004Z"
          stroke="#000001"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 9C9.5 9.53043 9.28929 10.0391 8.91421 10.4142C8.53914 10.7893 8.03043 11 7.5 11"
          stroke="#000001"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_11221">
          <rect width="18px" height="18px" fill="white" />
        </clipPath>
      </defs>
    </>
  )
}

export const ClockFastForwardIcon = () => {
  return (
    <>
      <path
        d="M22.7 11.5L20.7005 13.5L18.7 11.5M20.9451 13C20.9814 12.6717 21 12.338 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C14.8273 21 17.35 19.6963 19 17.6573M12 7V12L15 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const CreditCard02Icon = () => {
  return (
    <>
      <path
        d="M22 10H2M11 14H6M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const VolumeXIcon = () => {
  return (
    <>
      <path
        d="M22 9.00005L16 15M16 9.00005L22 15M9.63432 4.36573L6.46863 7.53142C6.29568 7.70437 6.2092 7.79085 6.10828 7.85269C6.01881 7.90752 5.92127 7.94792 5.81923 7.97242C5.70414 8.00005 5.58185 8.00005 5.33726 8.00005H3.6C3.03995 8.00005 2.75992 8.00005 2.54601 8.10904C2.35785 8.20492 2.20487 8.3579 2.10899 8.54606C2 8.75997 2 9.04 2 9.60005V14.4C2 14.9601 2 15.2401 2.10899 15.454C2.20487 15.6422 2.35785 15.7952 2.54601 15.8911C2.75992 16 3.03995 16 3.6 16H5.33726C5.58185 16 5.70414 16 5.81923 16.0277C5.92127 16.0522 6.01881 16.0926 6.10828 16.1474C6.2092 16.2093 6.29568 16.2957 6.46863 16.4687L9.63431 19.6344C10.0627 20.0627 10.2769 20.2769 10.4608 20.2914C10.6203 20.304 10.7763 20.2394 10.8802 20.1177C11 19.9774 11 19.6745 11 19.0687V4.93142C11 4.3256 11 4.0227 10.8802 3.88243C10.7763 3.76073 10.6203 3.69614 10.4608 3.7087C10.2769 3.72317 10.0627 3.93736 9.63432 4.36573Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </>
  )
}

export const VolumeMaxIcon = () => {
  return (
    <>
      <path
        d="M19.7479 5.00005C21.1652 6.97029 22 9.38768 22 12C22 14.6124 21.1652 17.0298 19.7479 19M15.7453 8.00005C16.5362 9.13388 17 10.5128 17 12C17 13.4873 16.5362 14.8662 15.7453 16M9.63432 4.36573L6.46863 7.53142C6.29568 7.70437 6.2092 7.79085 6.10828 7.85269C6.01881 7.90752 5.92127 7.94792 5.81923 7.97242C5.70414 8.00005 5.58185 8.00005 5.33726 8.00005H3.6C3.03995 8.00005 2.75992 8.00005 2.54601 8.10904C2.35785 8.20492 2.20487 8.3579 2.10899 8.54606C2 8.75997 2 9.04 2 9.60005V14.4C2 14.9601 2 15.2401 2.10899 15.454C2.20487 15.6422 2.35785 15.7952 2.54601 15.8911C2.75992 16 3.03995 16 3.6 16H5.33726C5.58185 16 5.70414 16 5.81923 16.0277C5.92127 16.0522 6.01881 16.0926 6.10828 16.1474C6.2092 16.2093 6.29568 16.2957 6.46863 16.4687L9.63431 19.6344C10.0627 20.0627 10.2769 20.2769 10.4608 20.2914C10.6203 20.304 10.7763 20.2394 10.8802 20.1177C11 19.9774 11 19.6745 11 19.0687V4.93142C11 4.3256 11 4.0227 10.8802 3.88243C10.7763 3.76073 10.6203 3.69614 10.4608 3.7087C10.2769 3.72317 10.0627 3.93736 9.63432 4.36573Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </>
  )
}

export const VolumeMinIcon = () => {
  return (
    <>
      <path
        d="M18.2451 8.00005C19.036 9.13388 19.4998 10.5128 19.4998 12C19.4998 13.4873 19.036 14.8662 18.2451 16M12.1343 4.36573L8.96863 7.53142C8.79568 7.70437 8.7092 7.79085 8.60828 7.85269C8.51881 7.90752 8.42127 7.94792 8.31923 7.97242C8.20414 8.00005 8.08185 8.00005 7.83726 8.00005H6.1C5.53995 8.00005 5.25992 8.00005 5.04601 8.10904C4.85785 8.20492 4.70487 8.3579 4.60899 8.54606C4.5 8.75997 4.5 9.04 4.5 9.60005V14.4C4.5 14.9601 4.5 15.2401 4.60899 15.454C4.70487 15.6422 4.85785 15.7952 5.04601 15.8911C5.25992 16 5.53995 16 6.1 16H7.83726C8.08185 16 8.20414 16 8.31923 16.0277C8.42127 16.0522 8.51881 16.0926 8.60828 16.1474C8.7092 16.2093 8.79568 16.2957 8.96863 16.4687L12.1343 19.6344C12.5627 20.0627 12.7769 20.2769 12.9608 20.2914C13.1203 20.304 13.2763 20.2394 13.3802 20.1177C13.5 19.9774 13.5 19.6745 13.5 19.0687V4.93142C13.5 4.3256 13.5 4.0227 13.3802 3.88243C13.2763 3.76073 13.1203 3.69614 12.9608 3.7087C12.7769 3.72317 12.5627 3.93736 12.1343 4.36573Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </>
  )
}

export const PlaceholderIcon = createIcon({
  displayName: 'PlaceholderIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
        fill="currentColor"
      />
    </>
  ),
})

export const BarChart02Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3C18.5523 3 19 3.44772 19 4V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V4C17 3.44772 17.4477 3 18 3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15C6.55228 15 7 15.4477 7 16V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V16C5 15.4477 5.44772 15 6 15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9C12.5523 9 13 9.44772 13 10V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V10C11 9.44772 11.4477 9 12 9Z"
        fill="currentColor"
      />
    </>
  )
}

export const BookOpen01Icon = () => {
  return (
    <>
      <path
        d="M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const MinusIcon = () => {
  return (
    <>
      <path d="M5 12H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  )
}

export const MessageSquare01Icon = () => {
  return (
    <>
      <path
        d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H9.68375C9.0597 18 8.74767 18 8.44921 18.0613C8.18443 18.1156 7.9282 18.2055 7.68749 18.3285C7.41617 18.4671 7.17252 18.662 6.68521 19.0518L4.29976 20.9602C3.88367 21.2931 3.67563 21.4595 3.50054 21.4597C3.34827 21.4599 3.20422 21.3906 3.10923 21.2716C3 21.1348 3 20.8684 3 20.3355V7.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const Target04Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1601 1.01292C19.4774 1.06441 19.7506 1.26529 19.8944 1.5528L20.7453 3.25466L22.4472 4.10558C22.7347 4.24934 22.9355 4.52254 22.987 4.83983C23.0385 5.15712 22.9343 5.47982 22.707 5.70712L19.707 8.70712C19.5195 8.89466 19.2652 9.00001 18.9999 9.00001H16.4142L12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929L14.9999 7.58585V5.00001C14.9999 4.7348 15.1053 4.48044 15.2928 4.29291L18.2928 1.29291C18.5201 1.06561 18.8428 0.961435 19.1601 1.01292Z"
        fill="currentColor"
      />
      <path
        d="M3 12C3 7.02944 7.02944 3 12 3C12.5523 3 13 2.55228 13 2C13 1.44772 12.5523 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 11.4477 22.5523 11 22 11C21.4477 11 21 11.4477 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        fill="currentColor"
      />
      <path
        d="M8 12C8 9.79086 9.79086 8 12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 11.4477 17.5523 11 17 11C16.4477 11 16 11.4477 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
        fill="currentColor"
      />
    </>
  )
}

export const Pencil02Icon = () => {
  return (
    <>
      <path
        d="M18.7071 1.29289C18.3166 0.902369 17.6834 0.902369 17.2929 1.29289C16.9024 1.68342 16.9024 2.31658 17.2929 2.70711L21.2929 6.70711C21.6834 7.09763 22.3166 7.09763 22.7071 6.70711C23.0976 6.31658 23.0976 5.68342 22.7071 5.29289L18.7071 1.29289Z"
        fill="currentColor"
      />
      <path
        d="M14.5365 4.28045C14.8378 4.18256 15.1623 4.18256 15.4635 4.28045C15.6962 4.35603 15.8648 4.48158 15.9759 4.57587C16.0717 4.65724 16.1723 4.75787 16.2564 4.84212L19.1578 7.74349C19.2421 7.82769 19.3427 7.92824 19.4241 8.02409C19.5184 8.13517 19.6439 8.30376 19.7195 8.5364C19.8174 8.83766 19.8174 9.16219 19.7195 9.46345C19.6439 9.69608 19.5184 9.86468 19.4241 9.97576C19.3427 10.0716 19.242 10.1722 19.1578 10.2564L8.7703 20.6439C8.58362 20.8308 8.41887 20.9958 8.22797 21.1348C8.05998 21.2572 7.87973 21.3618 7.69012 21.447C7.47465 21.5437 7.24969 21.6049 6.99479 21.6743L2.26314 22.9647C1.91693 23.0591 1.54667 22.9608 1.29292 22.707C1.03917 22.4533 0.940838 22.083 1.03526 21.7368L2.32569 17.0052C2.39504 16.7503 2.45624 16.5253 2.55298 16.3098C2.63811 16.1202 2.74272 15.94 2.86511 15.772C3.00419 15.5811 3.16915 15.4163 3.35606 15.2296L13.7436 4.84215C13.8278 4.75789 13.9283 4.65725 14.0242 4.57587C14.1353 4.48158 14.3039 4.35603 14.5365 4.28045Z"
        fill="currentColor"
      />
    </>
  )
}

export const DotPoints01Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12C8 11.4477 8.44772 11 9 11L21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L9 13C8.44772 13 8 12.5523 8 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6C8 5.44772 8.44772 5 9 5L21 5C21.5523 5 22 5.44772 22 6C22 6.55229 21.5523 7 21 7L9 7C8.44772 7 8 6.55228 8 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 18C8 17.4477 8.44772 17 9 17L21 17C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19L9 19C8.44772 19 8 18.5523 8 18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6C2 4.89543 2.89543 4 4 4C5.10457 4 6 4.89543 6 6C6 7.10457 5.10457 8 4 8C2.89543 8 2 7.10457 2 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 18C2 16.8954 2.89543 16 4 16C5.10457 16 6 16.8954 6 18C6 19.1046 5.10457 20 4 20C2.89543 20 2 19.1046 2 18Z"
        fill="currentColor"
      />
    </>
  )
}

export const BriefCase02Icon = () => {
  return (
    <>
      <path
        d="M8 21V7C8 6.07003 8 5.60504 8.10222 5.22354C8.37962 4.18827 9.18827 3.37962 10.2235 3.10222C10.605 3 11.07 3 12 3C12.93 3 13.395 3 13.7765 3.10222C14.8117 3.37962 15.6204 4.18827 15.8978 5.22354C16 5.60504 16 6.07003 16 7V21M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const Trash02Icon = () => {
  return (
    <>
      <path
        d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const DragGridIcon = () => {
  return (
    <>
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const TextInputIcon = () => {
  return (
    <>
      <path
        d="M13 7H5.2C4.0799 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.0799 2 10.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.07989 17 5.2 17H13M17 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H17M17 21L17 3M19.5 3.00001L14.5 3M19.5 21L14.5 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const Columns01Icon = () => {
  return (
    <>
      <path
        d="M6.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21H6.8C7.9201 21 8.48016 21 8.90798 20.782C9.28431 20.5903 9.59027 20.2843 9.78201 19.908C10 19.4802 10 18.9201 10 17.8V6.2C10 5.0799 10 4.51984 9.78201 4.09202C9.59027 3.71569 9.28431 3.40973 8.90798 3.21799C8.48016 3 7.9201 3 6.8 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        transform="rotate(90 12 12)"
      />
      <path
        d="M17.8 3H17.2C16.0799 3 15.5198 3 15.092 3.21799C14.7157 3.40973 14.4097 3.71569 14.218 4.09202C14 4.51984 14 5.0799 14 6.2V17.8C14 18.9201 14 19.4802 14.218 19.908C14.4097 20.2843 14.7157 20.5903 15.092 20.782C15.5198 21 16.0799 21 17.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        transform="rotate(90 12 12)"
      />
    </>
  )
}

export const Link01Icon = () => {
  return (
    <>
      <path
        d="M12.7076 18.3639L11.2933 19.7781C9.34072 21.7308 6.1749 21.7308 4.22228 19.7781C2.26966 17.8255 2.26966 14.6597 4.22228 12.7071L5.63649 11.2929M18.3644 12.7071L19.7786 11.2929C21.7312 9.34024 21.7312 6.17441 19.7786 4.22179C17.826 2.26917 14.6602 2.26917 12.7076 4.22179L11.2933 5.636M8.50045 15.4999L15.5005 8.49994"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const ArrowNarrowLeftIcon = () => {
  return (
    <>
      <path
        d="M20 12H4M4 12L10 18M4 12L10 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const UploadCloud0202Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 21C4.02944 21 0 16.9706 0 12C0 7.02944 4.02944 3 9 3C11.6837 3 14.0931 4.17464 15.742 6.03783C15.9913 6.01281 16.2441 6 16.5 6C20.6421 6 24 9.35786 24 13.5C24 17.6421 20.6421 21 16.5 21H9ZM7.29289 13.7071C7.68342 14.0976 8.31658 14.0976 8.70711 13.7071L11 11.4142L11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17L13 11.4142L15.2929 13.7071C15.6834 14.0976 16.3166 14.0976 16.7071 13.7071C17.0976 13.3166 17.0976 12.6834 16.7071 12.2929L12.7071 8.29289C12.3166 7.90237 11.6834 7.90237 11.2929 8.29289L7.29289 12.2929C6.90237 12.6834 6.90237 13.3166 7.29289 13.7071Z"
        fill="currentColor"
      />
    </>
  )
}

export const Bell01Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.60466 20.3383C8.97013 19.9242 9.60207 19.8848 10.0161 20.2503C10.5456 20.7176 11.2387 21 12.0002 21C12.7617 21 13.4549 20.7176 13.9843 20.2503C14.3984 19.8848 15.0303 19.9242 15.3958 20.3383C15.7613 20.7523 15.7219 21.3843 15.3078 21.7497C14.427 22.5272 13.2676 23 12.0002 23C10.7329 23 9.57348 22.5272 8.69267 21.7497C8.2786 21.3843 8.2392 20.7523 8.60466 20.3383Z"
        stroke="currentColor"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.05048 3.05025C8.36323 1.7375 10.1437 1 12.0002 1C13.8567 1 15.6372 1.7375 16.95 3.05025C18.2627 4.36301 19.0002 6.14349 19.0002 8C19.0002 10.9127 19.7322 12.8439 20.4996 14.0771L20.5115 14.0962C20.8688 14.6704 21.1512 15.1243 21.3416 15.4547C21.4371 15.6202 21.524 15.7797 21.5884 15.9215C21.6205 15.9922 21.6564 16.079 21.6845 16.1733C21.7078 16.2515 21.7522 16.4187 21.7356 16.6223C21.7244 16.7591 21.6965 16.9928 21.5623 17.2343C21.4282 17.4758 21.2445 17.623 21.1342 17.7047C20.8839 17.8904 20.5965 17.9329 20.5006 17.947L20.4961 17.9477C20.3487 17.9695 20.1815 17.9804 20.0127 17.9869C19.6774 18 19.2133 18 18.6361 18H5.36437C4.78715 18 4.32301 18 3.98775 17.9869C3.819 17.9804 3.65172 17.9695 3.50431 17.9477L3.49988 17.947C3.40396 17.9329 3.11653 17.8904 2.86623 17.7047C2.75599 17.623 2.57227 17.4758 2.43811 17.2343C2.30396 16.9928 2.27607 16.7591 2.26488 16.6223C2.24823 16.4187 2.29263 16.2515 2.31594 16.1733C2.34403 16.079 2.37997 15.9922 2.4121 15.9215C2.47646 15.7797 2.5634 15.6202 2.65882 15.4547C2.84925 15.1243 3.13172 14.6703 3.48905 14.0961L3.50084 14.0771C4.26822 12.8439 5.00023 10.9127 5.00023 8C5.00023 6.14348 5.73772 4.36301 7.05048 3.05025Z"
        stroke="currentColor"
        fill="none"
      />
    </>
  )
}

export const Bell02Icon = () => {
  return (
    <>
      <path
        d="M14 21H10M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const AlignJustifyIcon = () => {
  return (
    <>
      <path
        d="M21 10H3M21 18H3M21 6H3M21 14H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const PencilO2Icon = () => {
  return (
    <>
      <path
        d="M18 2L22 6M2 22L3.2764 17.3199C3.35968 17.0145 3.40131 16.8619 3.46523 16.7195C3.52199 16.5931 3.59172 16.4729 3.67332 16.3609C3.76521 16.2348 3.87711 16.1229 4.1009 15.8991L14.4343 5.56569C14.6323 5.36768 14.7313 5.26867 14.8455 5.23158C14.9459 5.19895 15.0541 5.19895 15.1545 5.23158C15.2687 5.26867 15.3677 5.36768 15.5657 5.56569L18.4343 8.43431C18.6323 8.63232 18.7313 8.73133 18.7684 8.84549C18.8011 8.94591 18.8011 9.05409 18.7684 9.15451C18.7313 9.26867 18.6323 9.36768 18.4343 9.56569L8.1009 19.8991C7.87711 20.1229 7.76521 20.2348 7.63908 20.3267C7.52709 20.4083 7.40692 20.478 7.28052 20.5348C7.13815 20.5987 6.98548 20.6403 6.68014 20.7236L2 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const ClipboardCheckIcon = () => {
  return (
    <>
      <path
        d="M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 15L11 17L15.5 12.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const CheckIcon = () => {
  return (
    <>
      <path
        d="M20 6L9 17L4 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const FileQuestion02Icon = () => {
  return (
    <>
      <path
        d="M20 9.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M14 11H8M10 15H8M16 7H8M16.5 15.0022C16.6762 14.5014 17.024 14.079 17.4817 13.81C17.9395 13.5409 18.4777 13.4426 19.001 13.5324C19.5243 13.6221 19.999 13.8942 20.3409 14.3004C20.6829 14.7066 20.87 15.2207 20.8692 15.7517C20.8692 17.2506 18.6209 18 18.6209 18M18.6499 21H18.6599"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const ImageXIcon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 8.5C5.5 6.84315 6.84315 5.5 8.5 5.5C10.1569 5.5 11.5 6.84315 11.5 8.5C11.5 10.1569 10.1569 11.5 8.5 11.5C6.84315 11.5 5.5 10.1569 5.5 8.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2H7.7587C6.95374 1.99999 6.28937 1.99998 5.74818 2.04419C5.18608 2.09012 4.66937 2.18868 4.18404 2.43598C3.43139 2.81947 2.81947 3.43139 2.43598 4.18404C2.18868 4.66937 2.09012 5.18608 2.04419 5.74818C1.99998 6.28937 1.99999 6.95372 2 7.75869V16.2413C1.99999 17.0463 1.99998 17.7106 2.04419 18.2518C2.09012 18.8139 2.18868 19.3306 2.43598 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C4.66937 21.8113 5.18608 21.9099 5.74818 21.9558C5.92356 21.9701 6.11188 21.9798 6.31374 21.9864C6.52305 22.0003 6.7734 22.0002 7.03144 22.0002C10.3543 22.0002 13.6771 22 17 22C17.0465 22 17.0924 22 17.1376 22C17.933 22.0005 18.5236 22.0008 19.0353 21.8637C20.4156 21.4938 21.4938 20.4156 21.8637 19.0353C22.039 18.381 22.0002 17.6805 22 17.0095C22.0018 16.8202 22.0001 16.6308 22.0001 16.4415C22.0006 15.9726 22.0011 15.5594 21.8923 15.1647C21.7969 14.8182 21.6399 14.4917 21.429 14.2007C21.1887 13.8692 20.8658 13.6114 20.4993 13.3189L17.6683 11.0541C17.4984 10.9182 17.3304 10.7838 17.1779 10.6797C17.0083 10.5639 16.7995 10.4436 16.5382 10.3766C16.1709 10.2824 15.7843 10.2946 15.4237 10.4118C15.1671 10.4951 14.9663 10.6283 14.8043 10.7545C14.6586 10.8681 14.4995 11.0128 14.3385 11.1592L5.83046 18.8938C5.61698 19.0878 5.41061 19.2754 5.2589 19.4395C5.19807 19.5054 5.10567 19.6077 5.01929 19.743C4.67627 19.5501 4.39723 19.2598 4.21799 18.908C4.1383 18.7516 4.07337 18.5274 4.03755 18.089C4.00078 17.6389 4 17.0566 4 16.2V7.8C4 6.94342 4.00078 6.36113 4.03755 5.91104C4.07337 5.47262 4.1383 5.24842 4.21799 5.09202C4.40973 4.7157 4.7157 4.40973 5.09202 4.21799C5.24842 4.1383 5.47262 4.07337 5.91104 4.03755C6.36113 4.00078 6.94342 4 7.8 4H12.5C13.0523 4 13.5 3.55229 13.5 3C13.5 2.44772 13.0523 2 12.5 2Z"
        fill="currentColor"
      />
      <path
        d="M17.2071 1.79289C16.8166 1.40237 16.1834 1.40237 15.7929 1.79289C15.4024 2.18342 15.4024 2.81658 15.7929 3.20711L17.5858 5L15.7929 6.79289C15.4024 7.18342 15.4024 7.81658 15.7929 8.20711C16.1834 8.59763 16.8166 8.59763 17.2071 8.20711L19 6.41421L20.7929 8.20711C21.1834 8.59763 21.8166 8.59763 22.2071 8.20711C22.5976 7.81658 22.5976 7.18342 22.2071 6.79289L20.4142 5L22.2071 3.20711C22.5976 2.81658 22.5976 2.18342 22.2071 1.79289C21.8166 1.40237 21.1834 1.40237 20.7929 1.79289L19 3.58579L17.2071 1.79289Z"
        fill="currentColor"
      />
    </>
  )
}

export const User01Icon = () => {
  return (
    <>
      <path
        d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const YoutubeIcon = () => {
  return (
    <>
      <path
        d="M21.5813 7.19989C21.4733 6.76846 21.2534 6.37318 20.9438 6.05395C20.6341 5.73473 20.2457 5.50287 19.8178 5.3818C18.2542 5 12 5 12 5C12 5 5.74578 5 4.18222 5.41816C3.75429 5.53923 3.36588 5.77109 3.05623 6.09031C2.74659 6.40954 2.52666 6.80482 2.41868 7.23625C2.13253 8.82303 1.99255 10.4327 2.00052 12.0451C1.99032 13.6696 2.1303 15.2916 2.41868 16.8903C2.53773 17.3083 2.76258 17.6886 3.0715 17.9943C3.38043 18.3 3.76299 18.5209 4.18222 18.6357C5.74578 19.0538 12 19.0538 12 19.0538C12 19.0538 18.2542 19.0538 19.8178 18.6357C20.2457 18.5146 20.6341 18.2827 20.9438 17.9635C21.2534 17.6443 21.4733 17.249 21.5813 16.8176C21.8653 15.2427 22.0052 13.6453 21.9995 12.0451C22.0097 10.4206 21.8697 8.79862 21.5813 7.19989Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 9.46533C9.75 8.98805 9.75 8.74941 9.84974 8.61618C9.93666 8.50008 10.0697 8.42744 10.2144 8.4171C10.3804 8.40525 10.5811 8.53429 10.9826 8.79239L14.9254 11.3271C15.2738 11.551 15.448 11.663 15.5082 11.8054C15.5607 11.9298 15.5607 12.0702 15.5082 12.1946C15.448 12.337 15.2738 12.449 14.9254 12.6729L10.9826 15.2076C10.5811 15.4657 10.3804 15.5948 10.2144 15.5829C10.0697 15.5726 9.93666 15.4999 9.84974 15.3838C9.75 15.2506 9.75 15.012 9.75 14.5347V9.46533Z"
        stroke="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
    </>
  )
}

// From figma not design
export const File05Icon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66667 1.34502C6.66667 1.32749 6.66667 1.31872 6.66591 1.30282C6.65018 0.973633 6.3607 0.684289 6.03151 0.668715C6.01562 0.667964 6.0104 0.667966 6.00001 0.667969H3.8391C3.30248 0.667962 2.85957 0.667956 2.49878 0.697433C2.12405 0.72805 1.77958 0.79376 1.45603 0.95862C0.954261 1.21428 0.546313 1.62223 0.290651 2.124C0.12579 2.44755 0.0600805 2.79202 0.0294637 3.16675C-1.39798e-05 3.52754 -7.54546e-06 3.97045 2.52565e-07 4.50708V11.4955C-7.54546e-06 12.0321 -1.39798e-05 12.4751 0.0294637 12.8359C0.0600805 13.2106 0.12579 13.5551 0.290651 13.8786C0.546313 14.3804 0.954261 14.7883 1.45603 15.044C1.77958 15.2088 2.12405 15.2746 2.49878 15.3052C2.85958 15.3347 3.30248 15.3346 3.83912 15.3346H8.16088C8.69752 15.3346 9.14042 15.3347 9.50122 15.3052C9.87595 15.2746 10.2204 15.2088 10.544 15.044C11.0457 14.7883 11.4537 14.3804 11.7093 13.8786C11.8742 13.5551 11.9399 13.2106 11.9705 12.8359C12 12.4751 12 12.0322 12 11.4955V6.66793C12 6.65757 12 6.6524 11.9993 6.63652C11.9837 6.30729 11.6943 6.01778 11.3651 6.00207C11.3492 6.00131 11.3405 6.00131 11.323 6.00131L8.37873 6.00131C8.21047 6.00133 8.04662 6.00135 7.90785 5.99001C7.75545 5.97756 7.57563 5.94818 7.39468 5.85599C7.1438 5.72815 6.93983 5.52418 6.81199 5.2733C6.7198 5.09235 6.69042 4.91253 6.67797 4.76013C6.66663 4.62136 6.66665 4.4575 6.66667 4.28924L6.66667 1.34502ZM3.33333 8.66797C2.96514 8.66797 2.66667 8.96645 2.66667 9.33464C2.66667 9.70283 2.96514 10.0013 3.33333 10.0013H8.66667C9.03486 10.0013 9.33333 9.70283 9.33333 9.33464C9.33333 8.96645 9.03486 8.66797 8.66667 8.66797H3.33333ZM3.33333 11.3346C2.96514 11.3346 2.66667 11.6331 2.66667 12.0013C2.66667 12.3695 2.96514 12.668 3.33333 12.668H7.33333C7.70152 12.668 8 12.3695 8 12.0013C8 11.6331 7.70152 11.3346 7.33333 11.3346H3.33333Z"
        fill="#currentColor"
      />
      <path
        d="M10.6053 4.66796C10.8011 4.66797 10.8989 4.66797 10.9791 4.61882C11.0923 4.5494 11.16 4.38586 11.129 4.25673C11.107 4.16529 11.0432 4.10152 10.9155 3.97399L8.69398 1.75245C8.56645 1.62479 8.50268 1.56096 8.41124 1.53898C8.28211 1.50794 8.11857 1.57564 8.04916 1.68886C8 1.76904 8 1.86691 8 2.06266L8 4.13461C8 4.32129 8 4.41463 8.03633 4.48593C8.06829 4.54865 8.11928 4.59964 8.182 4.6316C8.2533 4.66793 8.34664 4.66793 8.53333 4.66794L10.6053 4.66796Z"
        fill="currentColor"
      />
    </>
  )
}

export const PlusCircleIcon = () => {
  return (
    <>
      <path
        d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentFill"
      />
    </>
  )
}

export const BookClosedIcon = () => {
  return (
    <>
      <path
        d="M20 19V16H7C5.34315 16 4 17.3431 4 19M8.8 22H16.8C17.9201 22 18.4802 22 18.908 21.782C19.2843 21.5903 19.5903 21.2843 19.782 20.908C20 20.4802 20 19.9201 20 18.8V5.2C20 4.07989 20 3.51984 19.782 3.09202C19.5903 2.71569 19.2843 2.40973 18.908 2.21799C18.4802 2 17.9201 2 16.8 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </>
  )
}

export const BellRinging02Icon = () => {
  return (
    <>
      <path
        d="M14.0003 21H10.0003M2.29414 5.81989C2.27979 4.36854 3.06227 3.01325 4.32635 2.3M21.7025 5.8199C21.7169 4.36855 20.9344 3.01325 19.6703 2.3M18.0003 8C18.0003 6.4087 17.3682 4.88258 16.2429 3.75736C15.1177 2.63214 13.5916 2 12.0003 2C10.409 2 8.88288 2.63214 7.75766 3.75736C6.63244 4.88258 6.0003 6.4087 6.0003 8C6.0003 11.0902 5.22077 13.206 4.34996 14.6054C3.61542 15.7859 3.24816 16.3761 3.26162 16.5408C3.27653 16.7231 3.31516 16.7926 3.46207 16.9016C3.59476 17 4.19289 17 5.38915 17H18.6114C19.8077 17 20.4058 17 20.5385 16.9016C20.6854 16.7926 20.7241 16.7231 20.739 16.5408C20.7524 16.3761 20.3852 15.7859 19.6506 14.6054C18.7798 13.206 18.0003 11.0902 18.0003 8Z"
        stroke="#FFBE4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#FFBE4C"
      />
    </>
  )
}

export const DragIcon = () => {
  return (
    <>
      <path
        d="M33.5 18V14C33.5 12.9391 33.0786 11.9217 32.3284 11.1716C31.5783 10.4214 30.5609 10 29.5 10H13.5C12.4391 10 11.4217 10.4214 10.6716 11.1716C9.92143 11.9217 9.5 12.9391 9.5 14V30C9.5 31.0609 9.92143 32.0783 10.6716 32.8284C11.4217 33.5786 12.4391 34 13.5 34H17.5"
        stroke="#A4ABB8"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M1.5 2V2.02M9.5 2V2.02M17.5 2V2.02M25.5 2V2.02M1.5 10V10.02M1.5 18V18.02M1.5 26V26.02M21.5 22L39.5 28L31.5 32L27.5 40L21.5 22Z"
        stroke="#A4ABB8"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const PlusSquareIcon = () => {
  return (
    <>
      <path
        d="M12 8V16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const Scales01Icon = () => {
  return (
    <>
      <path
        d="M2 17V16.8498C2 16.5333 2 16.3751 2.02421 16.2209C2.0457 16.084 2.08136 15.9497 2.13061 15.8202C2.18609 15.6743 2.2646 15.5369 2.42162 15.2622L6 9M2 17C2 19.2091 3.79086 21 6 21C8.20914 21 10 19.2091 10 17M2 17V16.8C2 16.52 2 16.38 2.0545 16.273C2.10243 16.1789 2.17892 16.1024 2.273 16.0545C2.37996 16 2.51997 16 2.8 16H9.2C9.48003 16 9.62004 16 9.727 16.0545C9.82108 16.1024 9.89757 16.1789 9.9455 16.273C10 16.38 10 16.52 10 16.8V17M6 9L9.57838 15.2622C9.7354 15.5369 9.81391 15.6743 9.86939 15.8202C9.91864 15.9497 9.9543 16.084 9.97579 16.2209C10 16.3751 10 16.5333 10 16.8498V17M6 9L18 7M14 15V14.8498C14 14.5333 14 14.3751 14.0242 14.2209C14.0457 14.084 14.0814 13.9497 14.1306 13.8202C14.1861 13.6743 14.2646 13.5369 14.4216 13.2622L18 7M14 15C14 17.2091 15.7909 19 18 19C20.2091 19 22 17.2091 22 15M14 15V14.8C14 14.52 14 14.38 14.0545 14.273C14.1024 14.1789 14.1789 14.1024 14.273 14.0545C14.38 14 14.52 14 14.8 14H21.2C21.48 14 21.62 14 21.727 14.0545C21.8211 14.1024 21.8976 14.1789 21.9455 14.273C22 14.38 22 14.52 22 14.8V15M18 7L21.5784 13.2622C21.7354 13.5369 21.8139 13.6743 21.8694 13.8202C21.9186 13.9497 21.9543 14.084 21.9758 14.2209C22 14.3751 22 14.5333 22 14.8498V15M12 3V8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const MessageTextSquare01Icon = () => {
  return (
    <>
      <path
        d="M7 8.5H12M7 12H15M9.68375 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V20.3355C3 20.8684 3 21.1348 3.10923 21.2716C3.20422 21.3906 3.34827 21.4599 3.50054 21.4597C3.67563 21.4595 3.88367 21.2931 4.29976 20.9602L6.68521 19.0518C7.17252 18.662 7.41617 18.4671 7.68749 18.3285C7.9282 18.2055 8.18443 18.1156 8.44921 18.0613C8.74767 18 9.0597 18 9.68375 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  )
}

export const DotsVerticalIcon = () => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z"
        fill="currentColor"
      />
    </>
  )
}

export const MessageTextCircle02Icon = () => {
  return (
    <>
      <path
        d="M8 9.5H12M8 13H15M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const Share06Icon = () => {
  return (
    <>
      <path
        d="M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59166 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40807 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.1629C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const CheckSquareIcon = () => {
  return (
    <>
      <path
        d="M7.5 12L10.5 15L16.5 9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const CheckCircleIcon = () => {
  return (
    <>
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
}

export const VideoRecorderIcon = () => {
  return (
    <>
      <path
        d="M22 8.93137C22 8.32555 22 8.02265 21.8802 7.88238C21.7763 7.76068 21.6203 7.69609 21.4608 7.70865C21.2769 7.72312 21.0627 7.93731 20.6343 8.36569L17 12L20.6343 15.6343C21.0627 16.0627 21.2769 16.2769 21.4608 16.2914C21.6203 16.3039 21.7763 16.2393 21.8802 16.1176C22 15.9774 22 15.6744 22 15.0686V8.93137Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2 9.8C2 8.11984 2 7.27976 2.32698 6.63803C2.6146 6.07354 3.07354 5.6146 3.63803 5.32698C4.27976 5 5.11984 5 6.8 5H12.2C13.8802 5 14.7202 5 15.362 5.32698C15.9265 5.6146 16.3854 6.07354 16.673 6.63803C17 7.27976 17 8.11984 17 9.8V14.2C17 15.8802 17 16.7202 16.673 17.362C16.3854 17.9265 15.9265 18.3854 15.362 18.673C14.7202 19 13.8802 19 12.2 19H6.8C5.11984 19 4.27976 19 3.63803 18.673C3.07354 18.3854 2.6146 17.9265 2.32698 17.362C2 16.7202 2 15.8802 2 14.2V9.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </>
  )
}

export const CakeIcon = () => {
  return (
    <>
      <path
        d="M9.07828 7.72986L11.0833 5.54986C12.1527 4.38763 12.2863 3.37069 11.4841 2.49902M6.66662 4.37486V3.95819M16.6666 3.74986V3.33319M16.6666 11.2499V10.8332M14.9999 15.4165V14.9999M11.4841 10.3449L13.4891 8.16569C14.8263 6.71236 16.1633 6.71236 17.4999 8.16569M3.06245 17.4757C2.98799 17.5016 2.90778 17.5062 2.83086 17.489C2.75393 17.4718 2.68333 17.4334 2.62703 17.3782C2.57073 17.323 2.53095 17.2532 2.51218 17.1767C2.49341 17.1001 2.49639 17.0198 2.52078 16.9449L4.67912 7.67486C4.77912 7.36319 5.17912 7.27902 5.39745 7.52236L11.8608 13.809C11.9071 13.8611 11.9399 13.9239 11.9563 13.9917C11.9727 14.0595 11.9721 14.1303 11.9546 14.1978C11.9372 14.2653 11.9034 14.3275 11.8562 14.3789C11.809 14.4303 11.7499 14.4692 11.6841 14.4924L3.06245 17.4757Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>
  )
}

export const ClockIcon = () => {
  return (
    <>
      <path
        d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </>
  )
}

export const UserGroupIcon = createIcon({
  displayName: 'UserGroupIcon',
  viewBox: '0 0 16 16',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.069 2.01776C10.2329 1.68804 10.633 1.55358 10.9627 1.71743C12.1684 2.31662 12.9994 3.56196 12.9994 5.0026C12.9994 6.44324 12.1684 7.68859 10.9627 8.28777C10.633 8.45163 10.2329 8.31717 10.069 7.98745C9.90516 7.65773 10.0396 7.25761 10.3693 7.09375C11.1392 6.71114 11.666 5.91778 11.666 5.0026C11.666 4.08743 11.1392 3.29407 10.3693 2.91145C10.0396 2.7476 9.90516 2.34747 10.069 2.01776Z"
        fill="#666D80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.392 10.9054C11.5438 10.5699 11.9388 10.421 12.2742 10.5728C13.3928 11.079 14.3821 11.8955 15.1902 12.9241C15.4177 13.2136 15.3674 13.6327 15.0779 13.8602C14.7884 14.0876 14.3693 14.0373 14.1418 13.7478C13.4467 12.8631 12.6212 12.1933 11.7245 11.7876C11.3891 11.6358 11.2402 11.2408 11.392 10.9054Z"
        fill="#666D80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66602 5.0026C2.66602 2.97756 4.30764 1.33594 6.33269 1.33594C8.35773 1.33594 9.99936 2.97756 9.99936 5.0026C9.99936 7.02765 8.35773 8.66927 6.33269 8.66927C4.30764 8.66927 2.66602 7.02765 2.66602 5.0026Z"
        fill="#666D80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.80847 12.9241C2.20299 11.1492 4.14411 10.0026 6.33269 10.0026C8.52127 10.0026 10.4624 11.1492 11.8569 12.9241C12.0146 13.1247 12.0438 13.3978 11.9323 13.6274C11.8207 13.8569 11.5879 14.0026 11.3327 14.0026H1.33269C1.07747 14.0026 0.844658 13.8569 0.733093 13.6274C0.621529 13.3978 0.650797 13.1247 0.80847 12.9241Z"
        fill="#666D80"
      />
    </>
  ),
})

export const DotsHorizontal16Icon = createIcon({
  displayName: 'DotsHorizontal16Icon',
  viewBox: '0 0 16 16',
  path: (
    <>
      <path
        d="M7.99935 8.66927C8.36754 8.66927 8.66602 8.37079 8.66602 8.0026C8.66602 7.63441 8.36754 7.33594 7.99935 7.33594C7.63116 7.33594 7.33268 7.63441 7.33268 8.0026C7.33268 8.37079 7.63116 8.66927 7.99935 8.66927Z"
        stroke="#666D80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.666 8.66927C13.0342 8.66927 13.3327 8.37079 13.3327 8.0026C13.3327 7.63441 13.0342 7.33594 12.666 7.33594C12.2978 7.33594 11.9993 7.63441 11.9993 8.0026C11.9993 8.37079 12.2978 8.66927 12.666 8.66927Z"
        stroke="#666D80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33268 8.66927C3.70087 8.66927 3.99935 8.37079 3.99935 8.0026C3.99935 7.63441 3.70087 7.33594 3.33268 7.33594C2.96449 7.33594 2.66602 7.63441 2.66602 8.0026C2.66602 8.37079 2.96449 8.66927 3.33268 8.66927Z"
        stroke="#666D80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
})

export const BotIcon = () => (
  <>
    {/* Speech bubble body */}
    <path
      d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Three dots */}
    <circle cx="9" cy="10" r="1" fill="currentColor" />
    <circle cx="12" cy="10" r="1" fill="currentColor" />
    <circle cx="15" cy="10" r="1" fill="currentColor" />
  </>
)
